export default "__VITE_ASSET__e4bfcc61__"